import { Type } from 'class-transformer';
import { AccProjectDetailResultDto } from './acc-project-detail-result-dto';

export class AccDetailResultDto {
    @Type(() => AccProjectDetailResultDto)
    projectData: AccProjectDetailResultDto;
}
